import * as React from "react";

export const DenseListItemIcon = ({ children }: { children?: React.ReactNode }) => {
    return <div style={{ display: "inline-flex", minWidth: 30, flexShrink: 0 }}>{children}</div>;
};
